import React from "react";
import { Show, SimpleShowLayout, TextField } from "react-admin";

import { ActionsWithBackButton } from "../../../components/actionbars/ActionsWithBackButton";
import { DateTimeField } from "components/fields/DateFormatField";
import { MaskedTokenFieldOnce } from "components/fields/TokenField";
import { SelectEnumField } from "components/fields/SelectEnumField";
import { ThirdPartyField } from "components/fields/ThirdPartyField";
import { AppSecretType } from "entities/AppSecretType";


export const AppSecretsShow = (props) => (
	<Show actions={<ActionsWithBackButton />} {...props}>
		<SimpleShowLayout>
			<TextField source="id" />
			<ThirdPartyField source="oauth2_client_id" addLabel />
			<SelectEnumField source="type" enumObj={AppSecretType} enumName="app_secret_type" />
			<MaskedTokenFieldOnce
				source="secret"
				viewedField="secret_viewed"
				revealNotice="resources.app-secrets.reveal_notice"
				addLabel
			/>
			<DateTimeField source="created_at" withLocalTimeZone addLabel />
		</SimpleShowLayout>
	</Show>
);
